import vmClient from 'app/services/vmClient';
import { Entity, EntityStringId, IEntity, IEntityType } from 'app/types/entity';

export interface ISound extends IEntity {
  attributes: {
    id: EntityStringId;
    url: string;
  };
}

export type Sound = Entity<ISound>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Sound: IEntityType<ISound> = vmClient.defineClass({
  typeName: 'Sound',
  version: 1,
  lockable: true,
  persisted: true,

  attributes: {
    url: {
      type: 'string',
      notNull: true,
    },
  },
});
